import React from 'react';

/**
 * Renderiza el bloque AccumulatedPpaChart de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function AccumulatedPpaChart({
  v
}) {
  return v.tabPpa ? React.createElement(React.Fragment, null, v.text("\n          "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "2.083333vw minmax(0,1fr) 6.25vw",
      "gap": "0.740741vh",
      "flex": "1",
      "minHeight": "0"
    }
  }, v.text("\n            "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "justifyContent": "space-between",
      "font": "1.018519vh 'IBM Plex Mono',monospace",
      "color": "#5a667a",
      "textAlign": "right"
    }
  }, React.createElement("span", {}, v.text(v.ppaMax)), React.createElement("span", {}, v.text(v.ppaMid)), React.createElement("span", {}, v.text("0"))), v.text("\n            "), React.createElement("div", {
    "onMouseMove": v.ppaMove,
    "onMouseLeave": v.ppaLeave,
    "onWheel": v.ppaWheel,
    "onKeyDown": v.ppaKeyDown,
    "data-wheel-zoom": "1",
    "tabIndex": "0",
    "role": "img",
    "aria-label": "Pellets perdidos acumulados. Usa la rueda para cambiar la jaula y mueve el cursor para ver los valores por fecha.",
    "title": "Rueda: cambiar jaula · Cursor: ver valor por fecha",
    style: {
      "position": "relative",
      "borderLeft": "0.052083vw solid rgba(46,179,238,0.12)",
      "borderBottom": "0.092593vh solid rgba(46,179,238,0.12)",
      "overflow": "hidden",
      "outline": "none",
      "cursor": "crosshair",
      "overscrollBehavior": "contain"
    }
  }, v.text("\n              "), React.createElement("svg", {
    "viewBox": "0 0 600 100",
    "preserveAspectRatio": "none",
    style: {
      "position": "absolute",
      "inset": "0",
      "width": "100%",
      "height": "100%",
      "display": "block",
      "overflow": "hidden"
    }
  }, v.text("\n                "), React.createElement("path", {
    "d": "M0 50 H600",
    "stroke": "#1c2636",
    "fill": "none",
    "vectorEffect": "non-scaling-stroke",
    "strokeDasharray": "2 4"
  }, null), v.text("\n                "), React.createElement("path", {
    "d": v.selDayLine,
    "stroke": "#5a667a",
    "fill": "none",
    "vectorEffect": "non-scaling-stroke",
    "strokeDasharray": "3 3"
  }, null), v.text("\n                "), (v.ppaLines || []).map((l, index69) => React.createElement(React.Fragment, {
    key: index69
  }, v.text("\n                  "), React.createElement("path", {
    "d": l.d,
    "stroke": l.stroke,
    "strokeWidth": l.w,
    "fill": "none",
    "vectorEffect": "non-scaling-stroke",
    "strokeLinejoin": "round"
  }, null), v.text("\n                  "), React.createElement("path", {
    "onClick": l.onClick,
    "d": l.d,
    "stroke": "transparent",
    "strokeWidth": "10",
    "fill": "none",
    "vectorEffect": "non-scaling-stroke",
    style: {
      "cursor": "pointer",
      "pointerEvents": "stroke"
    }
  }, null), v.text("\n                "))), v.text("\n              ")), v.text("\n              "), React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "0",
      "bottom": "0",
      "left": v.ppaTipX,
      "width": "0.052083vw",
      "background": "#e4e9f0",
      "opacity": "0.65",
      "pointerEvents": "none",
      "display": v.ppaTipDisp,
      "zIndex": "2"
    }
  }, null), v.text("\n              "), React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "0.740741vh",
      "left": v.ppaTipX,
      "transform": v.ppaTipTx,
      "minWidth": "9.895833vw",
      "maxHeight": "calc(100% - 1.481481vh)",
      "overflowY": "auto",
      "display": v.ppaTipDisp,
      "flexDirection": "column",
      "gap": "0.37037vh",
      "padding": "0.740741vh 0.925926vh",
      "borderRadius": "0.740741vh",
      "border": "0.092593vh solid rgba(46,179,238,0.28)",
      "background": "rgba(4,10,20,0.96)",
      "boxShadow": "0 0.740741vh 2.222222vh rgba(0,0,0,0.4)",
      "pointerEvents": "none",
      "zIndex": "4",
      "fontSize": "1.111111vh"
    }
  }, React.createElement("div", {
    style: {
      "font": "600 1.111111vh 'IBM Plex Mono',monospace",
      "color": "#e4e9f0",
      "paddingBottom": "0.37037vh",
      "borderBottom": "0.092593vh solid rgba(46,179,238,0.14)"
    }
  }, v.text(v.ppaTipDate)), (v.ppaTipRows || []).map((r, index170) => React.createElement("div", {
    key: index170,
    style: {
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "space-between",
      "gap": "1.296296vh",
      "color": r.c,
      "fontWeight": r.fw
    }
  }, React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.364583vw",
      "height": "0.648148vh",
      "borderRadius": "50%",
      "background": r.c,
      "flex": "none"
    }
  }, null), v.text(r.name)), React.createElement("span", {
    style: {
      "fontFamily": "'IBM Plex Mono',monospace",
      "color": "#e4e9f0"
    }
  }, v.text(r.val))))), v.text("\n            ")), v.text("\n            "), React.createElement("div", {
    style: {
      "position": "relative",
      "overflow": "hidden"
    }
  }, v.text("\n              "), (v.ppaLines || []).map((l, index70) => React.createElement(React.Fragment, {
    key: index70
  }, v.text("\n                "), React.createElement("div", {
    "onClick": l.onClick,
    style: {
      "position": "absolute",
      "left": "0",
      "top": l.top,
      "transform": "translateY(-50%)",
      "font": "1.018519vh 'IBM Plex Mono',monospace",
      "fontSize": "0.925926vh",
      "cursor": "pointer",
      "whiteSpace": "nowrap",
      "color": l.lc,
      "fontWeight": l.fw
    }
  }, v.text(l.label)), v.text("\n              "))), v.text("\n            ")), v.text("\n          ")), v.text("\n          "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "2.083333vw minmax(0,1fr) 6.25vw",
      "gap": "0.740741vh",
      "font": "1.018519vh 'IBM Plex Mono',monospace",
      "color": "#5a667a"
    }
  }, v.text("\n            "), React.createElement("div", {}, null), v.text("\n            "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between"
    }
  }, (v.ppaXTicks || []).map((t, index171) => React.createElement("span", {
    key: t.key
  }, v.text(t.label)))), v.text("\n            "), React.createElement("div", {}, null), v.text("\n          ")), v.text("\n        ")) : null;
}
